@if (params?.checkpoints?.length > 0) {
  <table class="content-align-full">
    <th class="header big">
      Age
      <button mat-icon-button color="primary" [matTooltip]="'Affordability settings are based on players age'">
        <mat-icon class="icon-size">help</mat-icon>
      </button>
    </th>
    @for (checkpoint of params.checkpoints; track checkpoint) {
      <th class="header small">{{ checkpoint.ageMin }}-{{ checkpoint.ageMax }}</th>
    }
    <tr>
      <td class="align-top">
        <p><b>Global calendar month threshold</b></p>
        <p><i>Standard calendar month Modifiers apply</i></p>
      </td>
      @for (checkpoint of params.checkpoints; track checkpoint) {
        <td class="align-top">{{ checkpoint.netLossThreshold }}</td>
      }
    </tr>
    <tr>
      <td class="align-top"><b>Deposit sum reference</b></td>
      @for (checkpoint of params.checkpoints; track checkpoint) {
        <td class="align-top">
          {{ checkpoint.depositsSumReference }}
        </td>
      }
    </tr>
    <tr>
      <td class="align-top">
        <p><b>Deposit prompt thresholds</b></p>
        <p><i>Modifiers apply</i></p>
      </td>
      @for (checkpoint of params.checkpoints; track checkpoint) {
        <td class="align-top">
          <table class="inner-table">
            @for (depositsSumThreshold of checkpoint.depositsSumThresholds; track depositsSumThreshold) {
              <tr>
                <td>{{ depositsSumThreshold.value }} ({{ depositsSumThreshold.percentage }}%)</td>
              </tr>
            }
          </table>
        </td>
      }
    </tr>
    <tr>
      <td class="align-top"><b>Student occupation modifier</b></td>
      @for (checkpoint of params.checkpoints; track checkpoint) {
        <td class="align-top">{{ checkpoint.studentModifier }}%</td>
      }
    </tr>
    <tr>
      <td class="align-top"><b>Unemployed occupation modifier</b></td>
      @for (checkpoint of params.checkpoints; track checkpoint) {
        <td class="align-top">{{ checkpoint.unemployedModifier }}%</td>
      }
    </tr>
    @for (tuScoreModifier of params.checkpoints[0].tuAffordabilityModifiers; track tuScoreModifier; let i = $index) {
      <tr>
        <td class="align-top">Transunion score {{ tuScoreModifier.tuScore }} modifier</td>
        @for (checkpoint of params.checkpoints; track checkpoint) {
          <td class="align-top">{{ checkpoint.tuAffordabilityModifiers[i].affordabilityModifierPercentage }}%</td>
        }
      </tr>
    }
  </table>
} @else {
  @if (params) {
    <div>Inactive</div>
  }
}
